import { Extent } from './Extent.js';
import { SupportedLanguage } from '../utils/i18n.js';

export interface MapOptionsProps {
  elementId: string | HTMLDivElement;
  key?: string;
  style?: string;
  center?: [number, number];
  zoomStart?: number;
  projection?: any;
  pitch?: number;
  extent?: Extent;
  mapTilerKey?: string;
  mapboxKey?: string;
  mapControls?: boolean;
  disableWorkers?: boolean;
  language?: SupportedLanguage;
}

export class MapOptions implements MapOptionsProps {
  public elementId!: string | HTMLDivElement;
  public key?: string;
  public style?: string;
  public center?: [number, number];
  public zoomStart?: number;
  public projection?: any;
  public pitch?: number;
  public extent?: Extent;
  public mapTilerKey?: string;
  public mapboxKey?: string;
  public mapControls?: boolean;
  public disableWorkers: boolean = false;
  public language?: SupportedLanguage;

  constructor(options: MapOptionsProps) {
    if (!options.elementId) {
      throw new Error('MapOptions: elementId is required');
    }
    Object.assign(this, options);
    this.disableWorkers = options.disableWorkers ?? false;
  }
}
